import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { UiActionTypeEnum,  UiCommandEvent, UiCommandSourceEnum } from '@ui/cer-ui-types';

export class ParentDataArgs {
  public typeName: string;
  public row: any;
  public id: string;
  public topic: string;
  public stable: boolean;
}

@Injectable()
export class CerFormService {

  // Form sends event to all components visible on form (grids etc)
  public formCommand$: Subject<UiCommandEvent> = new Subject<UiCommandEvent>();
  public formCommandNext(event: UiCommandEvent) {
    this.formCommand$.next(event);
  }
  
  // Children sends event to form
  public childCommand$: Subject<UiCommandEvent> = new Subject<UiCommandEvent>();
  public childCommandNext(event: UiCommandEvent) {
    this.childCommand$.next(event);
  }
  
  // Parent/child data sync: Send new parent data selection
  public parentDataLatestTopicArray: {[key: string]: ParentDataArgs} = {}; // Latest parent data for each topic, read by child when child is created after parent data is broadcast
  public parentData$: Subject<ParentDataArgs> = new Subject<ParentDataArgs>();
  public parentDataNext(parentData: ParentDataArgs) {
    this.parentData$.next(parentData);
    this.parentDataLatestTopicArray[parentData.topic] = parentData;
  }
  
  private designChangeQueued: boolean = false;
  public formDesignChangeNext(actionType: UiActionTypeEnum, args: any = {}) {
    if (!this.designChangeQueued) {
      this.designChangeQueued = true;
      setTimeout(() => {
        this.designChangeQueued = false;
        var event: UiCommandEvent = { source: UiCommandSourceEnum.DesignChange, commandId: null, args: args, actionType: actionType, subAction: 'none', columnName: null };
        this.formCommandNext(event);
        //console.log('formDesignChangeNext', actionType);
      }, 200);
    }
  }

  public isFormPaneCommand(commandId: string) {
    return (commandId && commandId.length > 0 && commandId.startsWith('pane')) 
  }
}
